import React, { useState } from "react";

import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { accordionData } from "shared/constants/faq";

const FAQ: React.FC = () => {
  const [expanded, setExpanded] = useState<number | false>(false);

  const handleChange =
    (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ mb: 3 }} variant="h3">
        Часті запитання
      </Typography>
      {accordionData.map((item, index) => (
        <Accordion
          key={index}
          elevation={0}
          expanded={expanded === index}
          onChange={handleChange(index)}
        >
          <AccordionSummary>
            <Typography variant="h3">{item.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="grey800" sx={{ whiteSpace: "pre-line" }}>
              {item.text}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQ;
